module.exports = __webpack_public_path__ + "img/certificate.6e90bed5.jpg";